export const CHECKEMPLOYEE_CODE = "CHECKEMPLOYEE_CODE";
export const CHECKEMPLOYEE_CODE_SUCCESSFUL = "CHECKEMPLOYEE_CODE_SUCCESSFUL";
export const CHECKEMPLOYEE_CODE_FAILED = "CHECKEMPLOYEE_CODE_FAILED";